// Le sceau de certification, à côté du nom.
//
// Bleu, comme la coche de Facebook et de tous les autres : c'est un signal que
// le monde entier reconnaît déjà, et le reprendre évite d'avoir à l'expliquer.
// L'or de Koinonia reste pour ce qui est sacré — la croix, le verset, l'amen ;
// une vérification d'identité n'en fait pas partie.
//
// Un pasteur, une église, un responsable reconnu : le sceau dit « cette personne
// est bien celle qu'elle dit être », et rien d'autre. Il ne donne aucun droit.
//
// Il ne peut PAS s'accorder soi-même : seule la modération le pose, et c'est
// écrit dans les règles du serveur autant que dans l'application. Un sceau qu'on
// se donne à soi-même ne prouve rien.

import Icone from "./Icone.jsx";

/**
 * @param {object} p
 * @param {object} p.membre  la fiche du membre — rien ne s'affiche sans `certifie`
 * @param {number} p.taille  en pixels, pour suivre la taille du nom qu'il suit
 */
export default function Certifie({ membre, taille = 15 }) {
  if (!membre?.certifie) return null;
  return (
    <span
      className="certifie"
      title="Compte certifié par Koinonia"
      aria-label="Compte certifié"
      role="img"
    >
      <Icone nom="certifie" taille={taille} plein />
    </span>
  );
}
